import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "../../../styles/admins/invoices/invoice.css";

function ReportPrint(props) {
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({
    contentRef,
    onAfterPrint: () => {
      window.location.reload();
    },
  });

  window.onpopstate = (e) => {
    props.toggleHeader();
  };


  return (
    <section className="d-flex flex-column align-items-center">
      <h2 style={{ color: "white" }}>Reports</h2>
      <div
        className="invoice-outer col-12 report-outer"
        ref={contentRef}
      >
        <div className="invoice-details">
          <table className="invoice-table report-table">
            <thead style={{ backgroundColor: "#1111" }}>
              <tr>
                <th>Invoice No</th>
                <th>Guest Name</th>
                <th>Room No</th>
                                <th>From Location</th>
                <th>To Location</th>
                <th>Check-in Date</th>
                <th>Check-out Date</th>
                {props.id === 6 ? <th>Entry No</th> : <th>Status</th>}
                <th>Room Rent</th>
                <th>CGST Amount</th>
                <th>SGST Amount</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {props.reports.map((report) => (
                <tr key={report.booking_id}>
                  <td>{report.inv_no ?? report.booking_id}</td>
                  <td>{JSON.parse(report.guest_ids).name[0]}</td>
                  <td>{report.room_no}</td>
                                    <td>{report.from_location || '-'}</td>
                  <td>{report.to_location || '-'}</td>

                  <td>{new Date(report.from_date).toLocaleString()}</td>
                  <td>{new Date(report.to_date).toLocaleString()}</td>
                  {props.id === 6 ? (
                    <td>{report.remarks}</td>
                  ) : (
                    <td>
                      {report.checkout_status ? "Checked Out" : "Checked In"}
                    </td>
                  )}
                  <td>₹{report.total_amount}</td>
                  <td>₹{(parseFloat(report.tax_amount) / 2).toFixed(2)}</td>
                  <td>₹{(parseFloat(report.tax_amount) / 2).toFixed(2)}</td>
                  <td>
                    ₹
                    {(
                      parseFloat(report.total_amount) +
                      parseFloat(report.tax_amount)
                    ).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <br />

      <div className="d-flex">
      <button
  className="print-btn me-3"
 onClick={() => props.setShowReportPrint(false)}>
  Go Back
</button>
      <button className="print-btn" onClick={reactToPrintFn}>
        Print Report
      </button>
      </div>
    </section>
  );
}

export default ReportPrint;
